@if (showIssuesLabel) {
  <span class="order-text">Issues:</span>
}

@for (group of errorGroups; track group.abbreviation) {
  <div class="tooltip-button"
    placement="right"
    [attr.error-type]="group.abbreviation"
    #overlayOrigin="cdkOverlayOrigin" cdkOverlayOrigin>
    <span>{{group.abbreviation}}</span>
    <insight-popup-tooltip [overlayOrigin]="overlayOrigin" [noPadding]="true">
      <ng-template>
        <div class="tooltip-title">
          <span>{{group.typeName}}</span>

          <span class="error-guide">
            <a target="_blank" href="https://swankmp.clickhelp.co/articles/insight-messages">Error Guide</a>

            <span class="guide-backup">
              (<a target="_blank" href="https://swankmp.atlassian.net/wiki/spaces/ISFS/pages/4176773133/Insight+Help+and+Error+Guides">
                <mat-icon>picture_as_pdf</mat-icon> <span>Backup</span>
              </a>)
            </span>
          </span>
        </div>

        <div class="tooltip-messages">
          @for (error of group.errors; track $index) {
            <div class="tooltip-message" [class.tooltip-message-expanding]="error.showSimple">
              @if (error.lineNumber !== null) {
                <span class="line-number">Line {{error.lineNumber}}</span>
              }

              @if (error.showSimple) {
                <expanding-error [simpleMessage]="error.simpleMessage" [simpleMessageInfo]="error.simpleMessageInfo" [fullMessage]="error.fullMessage">
                </expanding-error>
              } @else {
                <span class="error-message" [innerHTML]="error.formattedMessage"></span>
              }
            </div>
          }
        </div>
      </ng-template>
    </insight-popup-tooltip>
  </div>
}
